<template>
  <v-form ref="form" @submit.prevent="onSubmit">
    <v-select
      v-model="form.subscription_end_date"
      :label="$t('label.when_cancel_subscription')"
      :items="cancellation_dates"
      :loading="localLoading"
      :error-messages="
        submit_error ? $t('error.subscription_cancellation_failed') : ''
      "
      @input="can_save = true"
      :rules="[v => !!v || $t('rules.field_required')]"
      validate-on-blur
    />

    <v-card-actions class="px-0">
      <v-btn text color="grey" :disabled="localLoading" @click="onCancel">
        {{ $t("button.cancel") }}
      </v-btn>
      <v-spacer />
      <div v-if="show_cancel_cancellation">
        <v-btn color="error" @click="onCancelCancellation">
          {{ $t("button.cancel_cancellation_subscription") }}
        </v-btn>
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        type="submit"
        :loading="localLoading"
        :disabled="!can_save"
      >
        {{ $t("button.cancel_subscription") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import Vue from "vue";

export default {
  name: "SubscriptionCancelForm",
  props: {
    item: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submit_error: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        ...this.item
      },
      can_save: false,
      cancellation_dates: [],
      localLoading: false
    };
  },
  computed: {
    show_cancel_cancellation() {
      return !!this.item.subscription_end_date;
    }
  },
  watch: {
    loading(val) {
      this.localLoading = val;
    },
    item() {
      this.form = {};
      this.form = { ...this.item };
      this.getCancellationDates();
      this.updateDisplayedSubscriptionEndDate();
    },
    cancellation_dates() {
      this.updateDisplayedSubscriptionEndDate();
    }
  },
  mounted() {
    this.getCancellationDates();
    this.can_save = false;
  },
  methods: {
    parseCancellationDates(dates) {
      let selectItems = [];
      for (let year of Object.keys(dates)) {
        selectItems.push({ header: year });
        for (let [text, value] of Object.entries(dates[year])) {
          selectItems.push({ text: Vue.filter("date")(text), value });
        }
        selectItems.push({ divider: true });
      }
      this.cancellation_dates = selectItems;
    },
    getCancellationDates() {
      this.localLoading = true;
      this.$store
        .dispatch("subscription/getCancellationDates", this.item.uuid)
        .then(response => {
          this.parseCancellationDates(response.data.dates);
          this.localLoading = false;
        })
        .catch(error => {
          this.localLoading = false;
          this.$emit("error", error);
        });
    },
    onSubmit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("submit", {
        dispatch: "subscription/cancelSubscription",
        data: this.form
      });
    },
    onCancelCancellation() {
      this.form.subscription_end_date = null;
      this.can_save = false;
      this.$emit("submit", {
        dispatch: "subscription/cancelSubscription",
        data: { uuid: this.item.uuid }
      });
      this.$emit("cancel");
    },
    onCancel() {
      this.form.subscription_end_date = null;
      this.can_save = false;
      this.$emit("cancel");
    },
    updateDisplayedSubscriptionEndDate() {
      if (this.item.subscription_end_date) {
        const found = this.cancellation_dates.find(
          cd =>
            cd.value === this.item.subscription_end_date ||
            cd.text === this.item.subscription_end_date
        );
        if (found) {
          this.form.subscription_end_date = found.value;
        }
      } else {
        this.form.subscription_end_date = null;
      }
    }
  }
};
</script>
